export default "__VITE_ASSET__A11zxqkc__"